import {StyleSheet} from 'react-native';
import Typography from '../../../../shared/constants/Typography';
import Colors from '../../../../shared/theme/colors';
import { palette } from '@shared/theme/colorGroups/palette.colors';

export const loaderOverlayStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: palette.opacity.black20,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },
    loaderBox: {
      alignItems: Typography.textAlign.centerAlign,
    },
    message: {
      marginTop: Typography.margin.margin10,
      fontSize: Typography.fontSize.fontSize16,
      color: Colors.black,
      textAlign: Typography.textAlign.centerAlign,
    },
    overlay: {position: 'absolute', top: 0, left: 0, right: 0, bottom: 0},
  });
